<div class="main ui container quote-builder">
  <div class="ui stackable two column grid quote-builder-main-grid">
    <div class="eleven wide column tasks quote-builder-catalog" id="sticky-search">
      <div class="quote-builder-search-row">
        <div class="quote-builder-search-field">
          <i class="search icon quote-builder-search-field-icon" aria-hidden="true"></i>
          <input
            class="quote-builder-search-input"
            type="text"
            v-model="catalogSearchText"
            @keydown.enter.prevent="runCatalogSearch"
            :placeholder="searchInputPlaceholder"
            :readonly="speechRecording"
            autocomplete="off"
          />
          <button
            type="button"
            class="quote-builder-mic-inset"
            :class="{ 'is-recording': speechRecording, disabled: !speechRecognitionAvailable }"
            :title="speechRecognitionAvailable ? (speechRecording ? 'Stop recording' : 'Voice input') : 'Voice input not supported'"
            @click="toggleSpeechInput"
          >
            <img :src="speechRecording ? micIconOn : micIconOff" alt="" class="quote-builder-mic-img" width="24" height="24" />
          </button>
          <button type="button" class="quote-builder-search-submit" @click="runCatalogSearch" aria-label="Search">
            <i class="arrow right icon"></i>
          </button>
        </div>
      </div>

      <nav class="quote-builder-breadcrumbs" aria-label="Category path">
        <app-breadcrumbs
          :segments="breadcrumbSegments"
          :view-mode="catalogViewMode"
          :is-at-root="isAtCategoryTreeRoot"
          @navigate-all="goToAllCategories"
          @navigate-segment="navigateBreadcrumbTo"
        />
      </nav>

      <div class="quote-builder-body">
        <div v-if="catalogViewMode === 'browse' && !subCategory && !loadingCategories" class="quote-category-tiles">
          <button
            type="button"
            class="quote-category-tile"
            v-for="cat in categoryTiles"
            :key="'cat-' + cat.id"
            @click="onCategoryTileClick(cat)"
          >
            <span class="quote-category-tile-label">{{ cat.name }}</span>
          </button>
        </div>

        <div v-if="loadingCategories" class="quote-builder-loading">
          <app-loader :small="true"></app-loader>
        </div>

        <div v-if="(catalogViewMode === 'search' || subCategory) && loading" class="quote-builder-loading">
          <app-loader :small="true"></app-loader>
        </div>

        <div
          class="quote-task-grid"
          v-if="(catalogViewMode === 'search' || subCategory) && !loading && catalogTasksList.length"
        >
          <app-quote-task-tile
            v-for="task in catalogTasksList"
            :key="'task-' + task.id + '-' + (task.company_id != null ? task.company_id : 'x')"
            :code="task.code"
            :title="task.title || task.name"
            :image-src="getImageUrl(task)"
            :price="catalogPreviewPrice(task)"
            @add="openTaskModal(task)"
          />
        </div>

        <div
          class="quote-builder-empty-tasks"
          v-if="(catalogViewMode === 'search' || subCategory) && !loading && !catalogTasksList.length"
        >
          <p v-if="catalogViewMode === 'search'">No tasks match your search.</p>
          <p v-else>No tasks in this category.</p>
        </div>
      </div>
    </div>

    <app-right-bar
      :parent_quote="quote"
      :parent_quote_items="quoteItems"
      :parent_calculateTask="calculateTask"
      :parent_calculateTaskCost="calculateTaskCost"
      :parent_editTask="editTask"
      :key="rightSidebarKey"
      @quote="quote = $event"
      @line-items-sync="onRightbarLineItemsSync"
      @reset-default-task-price-type="resetDefaultTaskPriceType">
    </app-right-bar>
  </div>

  <app-customer-modal v-if="customerModalVisible"
    :parent_quote="quote"
    @start="start"
    @back="$router.push('/')">
  </app-customer-modal>

  <app-calculated-modal v-if="calculatedModalVisible"
    :parent_task="task"
    :parent_addTask="addTask"
    :breadcrumb-segments="breadcrumbSegments"
    :catalog-view-mode="catalogViewMode"
    :is-at-category-tree-root="isAtCategoryTreeRoot"
    @breadcrumb-navigate-all="onTaskModalBreadcrumbNavigateAll"
    @breadcrumb-navigate-segment="onTaskModalBreadcrumbNavigateSegment"
    @close="calculatedModalVisible=false">
  </app-calculated-modal>

  <app-variables-modal v-if="variablesModalVisible"
    :parent_task="task"
    :edit="editingTask"
    :breadcrumb-segments="breadcrumbSegments"
    :catalog-view-mode="catalogViewMode"
    :is-at-category-tree-root="isAtCategoryTreeRoot"
    @breadcrumb-navigate-all="onTaskModalBreadcrumbNavigateAll"
    @breadcrumb-navigate-segment="onTaskModalBreadcrumbNavigateSegment"
    @add="addTask"
    @save="saveTask"
    @close="variablesModalVisible=false; editingTask=false;"
  ></app-variables-modal>

  <app-addon-modal v-if="addonModalVisible"
       :task="task"
       :addons="addons"
       :breadcrumb-segments="breadcrumbSegments"
       :catalog-view-mode="catalogViewMode"
       :is-at-category-tree-root="isAtCategoryTreeRoot"
       @add="configureTask"
       @breadcrumb-navigate-all="onTaskModalBreadcrumbNavigateAll"
       @breadcrumb-navigate-segment="onTaskModalBreadcrumbNavigateSegment"
       @close="addonModalVisible=false"
  ></app-addon-modal>

  <app-compare-drawer></app-compare-drawer>

  <app-compare-preview-modal
    :visible="comparePreviewOpen"
    @close="onComparePreviewClose"
    @add="addTaskFromCompare"
  ></app-compare-preview-modal>
</div>
